module.exports = __webpack_public_path__ + "static/img/product_01.32e3aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/product_01.png
// module id = h426
// module chunks = 0